module.exports = __webpack_public_path__ + "img/lang_php.12c15f06.svg";